<template>
  <div v-text="display"></div>
</template>

<script>
export default {
  props: {
    id: Number,
    display: String,
  },
}
</script>
